import { applyConstraintsOverride } from "../utils/configurationFunctions";

const getPassResultPropertyName = (valuePropertyName) => {
  if (valuePropertyName === "flickerDeltaVoltage") return "flickerPassResult";
  if (valuePropertyName === "flickerStartingDeltaVoltage") return "flickerStartingPassResult";
  if (valuePropertyName.includes("maxVoltDropPercent")) {
    return `${valuePropertyName}PassResult`;
  }
  if (
    [
      "impedanceLoopOperating",
      "impedanceSourceLoopOperating",
      "flickerP28Primary",
      "flickerP28Secondary",
      "threePhaseFaultCurrent",
      "phaseToPhaseFaultCurrent",
      "singlePhaseToEarthFaultCurrent",
    ].includes(valuePropertyName)
  ) {
    return `${valuePropertyName}PassResult`;
  }
  return "";
};

const returnAsset = (asset, value, constraint) => {
  if (asset[value]) {
    const passResultPropertyName = getPassResultPropertyName(value);
    if (passResultPropertyName) {
      asset[`${value}Constraint`] = !asset[passResultPropertyName];
    } else {
      asset[`${value}Constraint`] = asset[value] > constraint;
    }
  }
  return asset;
};

export const allFaults = (clientSettings, _formState) => {
  const { reference, localOverrideConfig } = _formState;
  const constraints = [];
  clientSettings.filterResults.forEach((category) => {
    category.info.forEach((res) => {
      if (res.season) {
        ["All", "summer", "winter"].forEach((season) => {
          if (res.options) {
            res.options.forEach((option) => {
              constraints.push({
                name: res.name,
                season: season,
                nonSeasonalValue: option.value,
                value: season + option.value,
                constraint: option.constraint,
                constraintCount: 0,
              });
            });
          } else {
            let constraint = res.constraint;
            // maxVoltRise is the only constraint evaluated in the front end which which can have a local override.
            if (res.value === "maxVoltRiseTotal") {
              constraint = applyConstraintsOverride(
                reference.constraints,
                localOverrideConfig,
              ).maxVoltRisePercent;
            }
            constraints.push({
              name: res.name,
              season: season,
              nonSeasonalValue: res.value,
              value: season + res.value,
              constraint: constraint,
              constraintCount: 0,
            });
          }
        });
      } else {
        if (res.options) {
          res.options.forEach((option) => {
            constraints.push({
              name: res.name,
              season: "",
              nonSeasonalValue: option.value,
              value: option.value,
              constraint: option.constraint,
              constraintCount: 0,
            });
          });
        } else {
          constraints.push({
            name: res.name,
            season: "",
            nonSeasonalValue: res.value,
            value: res.value,
            constraint: res.constraint,
            constraintCount: 0,
          });
        }
      }
    });
  });
  return constraints;
};

export const setConstraints = (clientSettings, _formState, network) => {
  const constraints = allFaults(clientSettings, _formState);
  Object.values(network).forEach((n) => {
    if (Array.isArray(n)) {
      n.forEach((asset) => {
        constraints.forEach((c) => {
          if (asset[c.value]) {
            returnAsset(asset, c.value, c.constraint);
            c.constraintCount += asset[`${c.value}Constraint`] ? 1 : 0;
          }
          switch (c.value) {
            case "feederFuseSize":
              c.constraintCount +=
                asset["hasFuseMaxCurrentWarning"] || asset["hasFeederFuseExceedsMaxWarning"]
                  ? 1
                  : 0;
              break;
          }
        });
      });
    }
  });
  return { network: network, constraints: constraints };
};

export const getConstraint = (asset, value) => {
  const passResultPropertyName = getPassResultPropertyName(value);
  if (passResultPropertyName) {
    return asset[passResultPropertyName] === false;
  }
  return asset[`${value}Constraint`];
};
